import * as React from "react";
import {  Link as LinkScroll } from 'react-scroll';
import { IProductCategoryModel } from "states/menu/menu.models";
import { IconFood, IconMenu } from "themes";
export interface ICategoryItemProps {
  model: IProductCategoryModel;
}

export function CategoryItem({model}: ICategoryItemProps) {
  
  return (
    <li className="category-li">
      {model && (
        <>
          <LinkScroll 
          activeClass="active" 
          absolute={true} 
          offset={-100} 
          duration={500} 
          spy={true} 
          smooth={true} 
          to={`cate-${model?.id}`} 
          className={`cursor-pointer  text-md flex uppercase cate-${model?.id} `}>
          <IconFood className="mr-2" width={20} /> 
          {model?.name}</LinkScroll>
        </>
      )}
    </li>
  );
}
